import React from "react";
import MemoryCard from "./MemoryCard";
import "./MemoryBoard.scss";

const MemoryBoard = ({
  cards,
  flippedCardIds,
  matchedPairIds,
  inputLocked,
  onCardClick,
  cardBackImageUrl,
  cardBackgroundColor,
}) => {
  const totalCards = cards.length;
  const sizeTierClass =
    totalCards <= 10
      ? "size-tier-1"
      : totalCards <= 20
      ? "size-tier-2"
      : "size-tier-3";

  return (
    <div className={`MemoryBoard ${sizeTierClass}`.trim()}>
      {cards.map((card) => {
        const isMatched = matchedPairIds.includes(card.pairId);
        return (
          <MemoryCard
            key={card.id}
            card={card}
            isFlipped={flippedCardIds.includes(card.id)}
            isMatched={isMatched}
            isDisabled={inputLocked}
            onClick={onCardClick}
            cardBackImageUrl={cardBackImageUrl}
            cardBackgroundColor={cardBackgroundColor}
          />
        );
      })}
    </div>
  );
};

export default MemoryBoard;
